import { render, staticRenderFns } from "./CommonCertificate.vue?vue&type=template&id=22db193c&scoped=true"
import script from "./CommonCertificate.vue?vue&type=script&lang=js"
export * from "./CommonCertificate.vue?vue&type=script&lang=js"
import style0 from "./CommonCertificate.vue?vue&type=style&index=0&id=22db193c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db193c",
  null
  
)

export default component.exports